module.exports = __webpack_public_path__ + "static/media/sensor-fire.d276bab6.svg";